import { Shield, X } from '@phosphor-icons/react'
import { Button } from '@/components/ui/button'
import { isImpersonating, getImpersonationInfo, stopImpersonation } from '@/utils/permissions'
import { useNavigate } from 'react-router-dom'

export function ImpersonationBanner() {
  const navigate = useNavigate()

  if (!isImpersonating()) return null

  const info = getImpersonationInfo()

  const handleStop = () => {
    stopImpersonation()
    navigate('/admin')
    window.location.reload()
  }

  return (
    <div className="bg-amber-500 text-black px-4 py-2 flex items-center justify-center gap-3 text-sm font-bold z-[100] relative">
      <Shield size={18} weight="fill" />
      <span>
        Modo Administrador — Navegando como Mestre de &quot;{info?.tableName || 'Campanha'}&quot;
      </span>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleStop}
        className="h-7 px-3 text-black hover:bg-amber-600 font-bold border border-black/20"
      >
        <X size={14} className="mr-1" />
        Encerrar
      </Button>
    </div>
  )
}
